import * as React from 'react';

import { InfrastructureMapTypes } from '../../../../components/Map/parts';
import { IRegularInfrastructureType, TRegularInfrastructureType } from '../../../../types/map';

export interface IInfrastructureMapTypesContainerProps {
  isInfrastructureMode: boolean;
  currentTypes: string[];
  onTypesChange: (types: string[]) => void;
  infrastructureTypes: IRegularInfrastructureType[] | null;
  futureTypes?: TRegularInfrastructureType[];
}

export const InfrastructureMapTypesContainer: React.FC<IInfrastructureMapTypesContainerProps> = props => {
  const { isInfrastructureMode, infrastructureTypes, currentTypes, onTypesChange, futureTypes } = props;

  if (!isInfrastructureMode || !infrastructureTypes) {
    return null;
  }

  return (
    <InfrastructureMapTypes
      futureTypes={futureTypes}
      types={infrastructureTypes}
      currentTypes={currentTypes}
      onTypesChange={onTypesChange}
    />
  );
};
